import type { DashboardResponse } from '@common/types/insights';
import axiosInstance from '@/services/axiosInstance';

export async function getDashboard(params: { lawFirmId?: number }) {
    return axiosInstance.get<DashboardResponse>('/api/v1/insights/dashboard', { params });
}
